import React from 'react';
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';

import MobileCardMenu from './MobileCardMenu';

const buttonStyles = {
  position: "absolute",
  right: 4,
  padding: "8px",
  color: (theme) => theme.palette.grey[500],
};

export const CloseButton = React.memo(({ isMobile, onClose, setFilterDrawer, cardId, card }) => {
  if (isMobile) {
    return (
      <MobileCardMenu buttonStyles={buttonStyles} cardId={cardId} card={card} />
    );
  }

  return (
    <IconButton
      aria-label="close"
      onClick={onClose}
      sx={{
        ...buttonStyles,
        top: 10,
      }}
    >
      <CloseIcon />
    </IconButton>
  );
})